import { render, staticRenderFns } from "./KarmaProgramViewInfo.vue?vue&type=template&id=61ace3ea&"
import script from "./KarmaProgramViewInfo.vue?vue&type=script&lang=js&"
export * from "./KarmaProgramViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports